import { render, staticRenderFns } from "./Step5TireInfoMobileRegion.vue?vue&type=template&id=c0bb4728&"
import script from "./Step5TireInfoMobileRegion.controller.js?vue&type=script&lang=js&"
export * from "./Step5TireInfoMobileRegion.controller.js?vue&type=script&lang=js&"
import style0 from "./Step5TireInfoMobileRegion.styles.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports